import { BootstrapError } from './BootstrapError';
import { InvalidPermissions } from '../invalid-permissions/InvalidPermisions';
import { Loading } from '../loading/Loading';
import TopNavBar from '../top-nav-bar/TopNavBar';
import { AppLayoutProps } from './AppLayout';

/** True when the layout shows the page itself rather than a centred state. */
export function rendersPage(props: AppLayoutProps): boolean {
  return props.status === 'success' && !!props.permissions && !!props.user;
}

export function AppLayoutRenderHelper(props: AppLayoutProps) {
  if (rendersPage(props)) {
    return (
      <>
        <TopNavBar {...props} />
        {props.children}
      </>
    );
  }

  if (props.status === 'success') {
    return (
      <>
        <TopNavBar {...props} />
        <InvalidPermissions />
      </>
    );
  }

  // Bootstrap data/token could not be obtained after recovery attempts were
  // exhausted — show an actionable retry/re-auth state, never an indefinite
  // spinner. The header (user name + logout) stays visible.
  if (props.status === 'error') {
    return (
      <>
        <TopNavBar {...props} hideTabs />
        <BootstrapError onRetry={props.onRetry} />
      </>
    );
  }

  // Loading (and any other transient state). The header must NEVER be gated
  // by status, so it persists alongside the spinner — a transient mid-session
  // load never removes the user name / logout.
  return (
    <>
      <TopNavBar {...props} hideTabs />
      <Loading showIcon />
    </>
  );
}
